/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_9_PInputs */

const en_privacy_9_p = /** @type {(inputs: Privacy_9_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We may update this policy. Material changes are announced on the site or by email before they take effect.`)
};

const id_privacy_9_p = /** @type {(inputs: Privacy_9_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami dapat memperbarui kebijakan ini. Perubahan penting diumumkan di situs atau lewat email sebelum berlaku.`)
};

/**
* | output |
* | --- |
* | "We may update this policy. Material changes are announced on the site or by email before they take effect." |
*
* @param {Privacy_9_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_9_p = /** @type {((inputs?: Privacy_9_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_9_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_9_p(inputs)
	return en_privacy_9_p(inputs)
});